import { jsx as b } from "react/jsx-runtime";
import { c as J } from "../../index-C3-ZVs5E.js";
import { useRef as m, useState as i, useCallback as N, useMemo as L, useEffect as u } from "react";
import '../../assets/JsonInput.css';const M = "_input_1wmyx_2", P = {
  input: M
}, w = ({
  onChange: e,
  initialContent: n = "",
  className: y,
  ...d
}) => {
  const c = m(null), a = m(null), [f, E] = i(!1), [r, x] = i(null), [l, j] = i(
    typeof n == "string" ? {
      text: n
    } : {
      json: n
    }
  ), p = N(
    (t) => {
      j(t);
      try {
        const s = "json" in t ? t.json : JSON.parse(t.text);
        e == null || e(s);
      } catch {
      }
    },
    [e]
  ), o = L(
    () => ({
      ...d,
      onChange: p,
      content: l,
      mode: "text",
      mainMenuBar: !1,
      navigationBar: !1
    }),
    [d, p, l]
  );
  return u(() => {
    (async () => {
      const t = await import("../../index-Ch89hJpO.js");
      a.current = t.JSONEditor, E(!0);
    })();
  }, []), u(() => {
    if (!c.current || !a.current || r || !f)
      return;
    const t = c.current, s = new a.current({
      target: t,
      props: o
    });
    return x(s), () => {
      r && s.destroy();
    };
  }, [o, r, f]), u(() => {
    r && r.updateProps(o);
  }, [o, r]), /* @__PURE__ */ b("div", { ref: c, className: J(P.input, y) });
};
export {
  w as JsonEditor
};
